/*global FB*/
const BASIC_SCOPES = "public_profile,email";
const PAGES_SCOPES = `${BASIC_SCOPES},pages_show_list,pages_manage_metadata,pages_messaging,pages_read_engagement`;

/**
 * Iniciar sesion en facebook
 * @return {Promise<void>}
 */
export function fbLogin({ pageScope = false } = {}) {
  // try {
  return new Promise((resolve, reject) => {
    FB.login(
      (response) => {
        console.log("Facebook/fbLogin() rpta ->", JSON.stringify(response));
        if (response.authResponse) {
          return resolve(response);
        } else {
          console.log("User cancelled login or did not fully authorize.");
          return reject(response);
        }
      },
      {
        scope: pageScope ? PAGES_SCOPES : BASIC_SCOPES,
      }
    );
  }).catch((e) => console.error("[messengerModule][fbLogin]", e));
  // } catch (e) {
  // console.error("[messengerModule][fbLogin]", e);
  // }
}

/**
 * Obtener access token de usuario de larga duración
 * @param context
 * @param accessToken
 * @return {Promise<void>}
 */
export async function fbLongUserAccessToken(accessToken) {
  const facebookAppId = import.meta.env.VITE_FACEBOOK_ID;
  const facebookAppSecret = import.meta.env.VITE_FACEBOOK_CLIENT_SECRET;

  try {
    const url = `/oauth/access_token?grant_type=fb_exchange_token&client_id=${facebookAppId}&client_secret=${facebookAppSecret}&fb_exchange_token=${accessToken}`;
    return await new Promise((resolve, reject) => {
      FB.api(url, async (response) => {
        console.log("Facebook/longUserAccessToken() rpta ->", response);
        if (response.access_token) {
          return resolve(response);
        } else {
          console.log("User cancelled login or did not fully authorize.");
          return reject(response);
        }
      });
    });
  } catch (e) {
    console.error("[messengerModule][fbLongUserAccessToken]", e);
  }
}

/**
 * Obtener nombre y id de la cuenta de facebook
 * @param userId
 * @return {Promise<void>}
 */
export async function fbUserInformation(userId) {
  try {
    const url = `${userId}`;
    return await new Promise((resolve, reject) => {
      FB.api(url, async (response) => {
        console.log("Facebook/fbUserInformation() rpta ->", response);
        if (response.id) {
          resolve(response);
        } else {
          reject(null);
        }
      });
    });
  } catch (e) {
    console.error("[messengerModule][fbUserInformation]", e);
  }
}

/**
 * Listar paginas de facebook que se quieren vincular
 * @param context
 * @param userId
 * @param userAccessToken
 * @return {Promise<void>}
 */
export async function fbAccounts({ userId, userAccessToken }) {
  try {
    const url = `${userId}/accounts`;
    return await new Promise((resolve, reject) => {
      FB.api(
        url,
        {
          access_token: userAccessToken,
          fields: "name,access_token,picture",
        },
        async (response) => {
          console.log("Facebook/fbAccounts() rpta ->", response);
          if (response.data.length) {
            resolve(response);
          } else {
            reject(null);
          }
        }
      );
    });
  } catch (e) {
    console.error("[messengerModule][fbAccounts]", e);
  }
}

/**
 * Suscribir páginas de facebook a mi app de facebook
 * @param context
 * @param pageId
 * @param pageAccessToken
 * @return {Promise<void>}
 */
export async function fbSubscribeApps({ pageId, pageAccessToken }) {
  try {
    const url = `${pageId}/subscribed_apps`;
    const fields =
      "name,picture,messages,message_reactions,message_deliveries,messaging_postbacks,message_reads,messaging_optins,phone,email";
    return await new Promise((resolve, reject) => {
      FB.api(
        url,
        "post",
        { access_token: pageAccessToken, subscribed_fields: fields },
        async (response) => {
          console.log("Facebook/fbSubscribeApps() rpta ->", response);
          if (response.success) {
            return resolve(response);
          } else {
            return reject(response);
          }
        }
      );
    });
  } catch (e) {
    console.error("[messengerModule][fbSubscribeApps]", e);
  }
}

/**
 * Listar páginas de facebook suscritas a mi app de facebook
 * No se usa
 * @param context
 * @param pageId
 * @param pageAccessToken
 * @returns {Promise<void>}
 */
export async function fbSubscribedApps({ pageId, pageAccessToken }) {
  try {
    const url = `${pageId}/subscribed_apps?access_token=${pageAccessToken}`;

    return await new Promise((resolve, reject) => {
      FB.api(url, async (response) => {
        if (response.data.length) {
          return resolve(response);
        } else {
          return reject(response);
        }
      });
    });
  } catch (e) {
    console.error("[messengerModule][fbSubscribedApps]", e);
  }
}

/**
 * Desvincular página de facebook
 * @param context
 * @param pageId
 * @param pageAccessToken
 * @return {Promise<void>}
 */
export async function fbUnlinkPage({ pageId, pageAccessToken }) {
  try {
    const url = `${pageId}/subscribed_apps?access_token=${pageAccessToken}`;
    console.log("url", url);
    return await new Promise((resolve, reject) => {
      FB.api(url, "delete", async (response) => {
        console.log("Facebook/fbUnlinkPage() rpta ->", response);
        if (response.success) {
          resolve(response);
        } else {
          reject(response.error);
        }
      });
    });
  } catch (e) {
    console.error("[messengerModule][fbUnlinkPage]", e);
  }
}
